import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler,
         HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { take, mergeMap, catchError, timeout } from 'rxjs/operators';

import { AngularFireAuth } from '@angular/fire/compat/auth';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AngularFireAuth) { }

  // Public endpoints that should NOT send auth headers
  // (backend returns 401 if unrecognized token is sent to these)
  private publicEndpoints = [
    '/api/documents/',
    '/api/documents/?',
  ];

  private isPublicEndpoint(url: string): boolean {
    return this.publicEndpoints.some(endpoint => url.includes(endpoint));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip auth for public endpoints - they work without auth
    // and return 401 if an unrecognized user sends a token
    if (this.isPublicEndpoint(request.url)) {
      return next.handle(request);
    }

    return this.auth.authState.pipe(
      take(1),
      timeout(2000), // Don't wait forever for auth state
      catchError(() => of(null)), // If timeout or error, treat as no user
      mergeMap((user) => {
        console.log('auth', user);
        if ( user && user.uid ) {
          return from(user.getIdTokenResult()).pipe(
            catchError(() => {
              // If token fetch fails, proceed without auth header
              return of(null);
            }),
            mergeMap((token) => {
              if (token && token.token) {
                let headers = request.headers
                  .set('X-Authorization', `firebase ${user.uid}`)
                  .set('Authorization', `FirebaseToken ${token.token}`);
                if (window.localStorage.getItem('imposter')) {
                  headers = headers
                    .set('X-Imposter', window.localStorage.getItem('imposter'));
                }
                const newReq = request.clone({ headers });
                return next.handle(newReq);
              } else {
                // No valid token, proceed without auth header
                return next.handle(request);
              }
            })
          );
        } else {
          return next.handle(request);
        }
      })
    );
  }
}
